import React from "react";
import { UseDownloadAsset } from "../../../api/calls/Queries";

export default function BottomBarThumbnail({
  thumb,
}: {
  thumb: string | undefined;
}) {
  const { data: imageBlob } = UseDownloadAsset(thumb);

  return (
    <>
      {imageBlob && (
        <img
          src={imageBlob}
          alt={thumb}
          loading="lazy"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            pointerEvents: "none",
          }}
        />
      )}
    </>
  );
}
